/* External */
import mapValues from 'lodash/mapValues';

/* Services */
import content from './content';
import entitlement from './entitlement';
import experience from './experience';

/* Utils */
import { VERSION_MW_1 } from '../utils';

/**
 * @typedef VersionApiByServiceType
 * @type {object}
 * @property {'v1'} [content]
 * @property {'v1'} [entitlement]
 * @property {'v1'} [experience]
 */

/**
 * @param {VersionApiByServiceType} [versionApiByService]
 */
export default function blim(versionApiByService) {
  const serviceCreators = {
    content: content[versionApiByService?.content || VERSION_MW_1],
    entitlement: entitlement[versionApiByService?.entitlement || VERSION_MW_1],
    experience: experience[versionApiByService?.experience || VERSION_MW_1],
  };

  return (backendAxiosInstance) => (
    mapValues(serviceCreators, (service) => service(backendAxiosInstance))
  );
}
